import { Address as MicroserviceAddress } from '@sxm-de/dev-kits/microservices-sdk/types';
import { SxmTypeAddress } from '@sxm-de/dev-kits/web-sdk/types';

export function mapSmsAddressToAddress(
    address: MicroserviceAddress,
): SxmTypeAddress {
    return {
        addressLine1: address.streetAddress ?? '',
        addressLine2: '',
        city: address.city ?? '',
        state: address.state ?? '',
        zip: address.postalCode ?? '',
        country: address.country ?? '',
    };
}
